import i18next, { InitOptions } from 'i18next';
import { customFormatDate } from '../../utils';

export const configureI18n = async (
  initI18n: (languagePath: string, i18nOptions: InitOptions) => Promise<void>,
) => {
  const languagePath = 'locales/{{lng}}.json';
  const i18nOptions = {
    backend: {
      loadPath: languagePath, // This will probably be overridden in the initI18n callback
    },
    debug: true,
    lng: 'en', // default language
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  };
  const SHORT_DATE_FORMAT = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  };
  await initI18n(languagePath, i18nOptions);
  i18next.services.formatter.add('short_date_format', (value, lng) => {
    return customFormatDate(value, SHORT_DATE_FORMAT, lng);
  });
};
